import React, { Component } from "react";
import {
  Jumbotron,
  Container,
  Row,
  Col,
  Button,
  CardImg,
  Card,
  CardBody,
  Form
} from "reactstrap";
import { Link } from "react-router-dom";
import "./style.css";
import handleValidation from "../Validation";
import Questionform from '../AboutUsPage/QuestionForm';

class LandingPage extends Component {
  constructor() {
    super();
    this.state = {
      firstName: "",
      email: "",
      errors: {},
      errorsdiv: false
    };
  }

  submitDetails = event => {
    debugger;

    let formData = {
      first_name: this.refs.first_name.value,
      email: this.refs.email.value,
    
    };
    let errors = handleValidation(formData);
    this.setState({ errors: errors });
    if (errors["valid"] === true) {
      document.getElementById("companies").action =
        "https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8";
      document.getElementById("companies").method = "POST";
    } else {
      this.setState({ errorsdiv: true });
      event.preventDefault();
    }
  };

  render() {
    console.log(this.props.location.pathname);
    return (
      <div className="section-padding dark-background text-center overflow">
        <Jumbotron fluid className="dark-background jumbo pb-0 pt-2">
          <Row>
            <Col sm={{ offset: 2 }}>
              <CardImg
                style={{
                  borderRadius: "0",
                  width: "255px",
                  height: "61px"
                }}
                top
                className="ml-3 mb-5"
                src="img/lighthouse-logo.png"
                alt="Card image cap"
              />
            </Col>
          </Row>
          <Row className="text-left justify-content-center justify-content-lg-start">
            <Col
              xs={{ size: 11, order: 1 }}
              sm={{ size: 8 }}
              lg={{ size: 5, offset: 2, order: 1 }}
            >
              <h1>
                Technology Is Advancing At An Exponential Rate, Even Here In
                Atlanta.
              </h1>
              <h2 className="mt-4" style={{ color: "white" }}>
                How will you make sure your work stays relevant?
              </h2>
            </Col>
            <Col
              xs={{ size: 12, order: 3 }}
              lg={{ size: 4, order: 2 }}
              className="lp-form-col"
            >
              <Row className="justify-content-center">
                <Col
                  xs={{ size: 10 }}
                  lg={{ size: 12 }}
                  className="position-relative"
                >
            
                  <form
                    id="companies"
                    action="https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8"
                    method="POST"
                    onSubmit={this.submitDetails.bind(this)}
                  >
                    <input type="hidden" name="oid" value="00D3i000000GUvA" />
                    <input type="hidden" name="lead_source" value="Website" />
                    <input
                      type="hidden"
                      name="00N3i00000Bm5C9"
                      value="learningpage_v1"
                    />
                    <input
                      type="hidden"
                      name="retURL"
                      value="https://atlighthouse.com/thank-you"
                    />
                    <div
                      style={{ backgroundColor: "white", borderRadius: "5px" }}
                      className="p-3 jumbo-form"
                    >
                      <Row>
                        <Col>
                          <h3 className="red text-center pb-2">
                            Learn More About Our Approach
                          </h3>
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <label
                            style={{ color: "black" }}
                            className="apply-now-labels"
                            for="full_name"
                          >
                            Name<p className="required-symbol">{"*"}</p>
                          </label>
                          <input
                            style={{ backgroundColor: "#bdbdbd" }}
                            id="first_name"
                            maxlength="60"
                            name="first_name"
                            className="input-form form-control"
                            size="20"
                            type="text"
                            ref="first_name"
                            placeholder="Full Name"
                          />
                          {this.state.errorsdiv === true ? (
                            <span className="error">
                              {this.state.errors["first_name"]}
                            </span>
                          ) : (
                            ""
                          )}

                          <br />
                        </Col>
                        <Col>
                          <label
                            style={{ color: "black" }}
                            className="apply-now-labels"
                            for="email"
                          >
                            Email<p className="required-symbol">{"*"}</p>
                          </label>
                          <input
                            style={{ backgroundColor: "#bdbdbd" }}
                            id="email"
                            maxLength="80"
                            name="email"
                            size="20"
                            type="email"
                            className="input-form form-control"
                            ref="email"
                            placeholder="Email"
                          />
                          {this.state.errorsdiv === true ? (
                            <span className="error">
                              {this.state.errors["email"]}
                            </span>
                          ) : (
                            ""
                          )}

                          <br />
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <label
                            style={{ color: "black" }}
                            className="apply-now-labels text-left"
                            for="exampleSelect"
                          >
                            Which field of technology are you interested in?
                          </label>
                          <select
                            style={{ backgroundColor: "#bdbdbd" }}
                            id="00N3i00000Bkld5"
                            name="00N3i00000Bkld5"
                            title="Which course are you applying for?"
                            className="apply-now-inputs form-control"
                          >
                            <option value=""></option>
                            <option value="Full Stack Web Development">
                              Software Engineering
                            </option>
                            <option value="Full Stack Web Development">
                              Full Stack Web Development
                            </option>
                            <option value="Data Science and Analytics">
                              Data Science and Analytics
                            </option>
                            <option value="Digital Marketing">
                              Digital Marketing
                            </option>
                            <option value="Experience Design">
                              Experience Design
                            </option>
                          </select>
                          <br />
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <label
                            style={{ color: "black" }}
                            className="apply-now-labels text-left"
                            for="exampleSelect"
                          >
                            If you were to take a course, when would you plan to
                            start?
                          </label>
                          <select
                            style={{ backgroundColor: "#bdbdbd" }}
                            id="00N3i00000Bkld5"
                            name="00N3i00000Bkld5"
                            title="Which course are you applying for?"
                            className="apply-now-inputs form-control"
                          >
                            <option value=""></option>
                            <option value="Immediate">Immediate</option>
                            <option value="One to three months">
                              One to three months
                            </option>
                            <option value="Three to six months">
                              Three to six months
                            </option>
                            <option value="Six months to one year">
                              Six months to one year
                            </option>
                            <option value="Not sure">Not sure</option>
                          </select>
                          <br />
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <p style={{ fontSize: ".75rem", color: "black" }}>
                            <input type="checkbox" /> Yes, I opt-in to recieve
                            information about Lighthouse and it's stay relevant
                            resources.
                          </p>
                        </Col>
                      </Row>
                      <div className="d-flex">
                        {/* <Button
                          type="submit"
                          name="submit"
                          className="mt-2 ml-auto mb-2 inverse-color-btn"
                        >
                          Learn More
                        </Button> */}
                      </div>

                      <div>
                      <input
                        type="submit"
                        name="submit"
                        className="courses-button btn-secondary"
                      />
                    </div>

                      <p
                        className="privacy-terms mt-0"
                        style={{ color: "#47464c" }}
                      >
                        <i>
                          By providing your email, you agree to our{" "}
                          <u>
                            <Link
                              style={{ color: "#47464c" }}
                              to="/privacy-policy"
                            >
                              privacy policy
                            </Link>
                          </u>{" "}
                          and{" "}
                          <u>
                            <Link
                              style={{ color: "#47464c" }}
                              to="/terms-of-service"
                            >
                              terms of conditions
                            </Link>
                          </u>
                        </i>
                        .
                      </p>
                    </div>
                  </form>
                </Col>
              </Row>
            </Col>
            <Col
              xs={{ size: 12, order: 2 }}
              lg={{ size: 6, offset: 1, order: 3 }}
            >
              <CardImg
                top
                className="mt-4"
                src="img/landing-page-atl-skyline-jumbo-v2.png"
                alt="Card image cap"
              />
            </Col>
          </Row>
        </Jumbotron>
        <div style={{ backgroundColor: "white" }}>
          <Container>
            <Row>
              <Col sm={{ size: 8, offset: 2 }}>
                <h2 style={{ marginTop: "9rem" }}>Our Mission</h2>
                <h1 style={{ color: "black" }} className="mt-2 mb-3">
                  Stay Relevant, Forever
                </h1>
                <hr className="heading-underline mb-4" />
                <p style={{ color: "black" }} className="mb-5">
                  Lighthouse is a talent markeplace and education institution
                  that focuses on evolving your career based on what skills the
                  market needs. Our curriculum and expert instructors are guided
                  by our four principles:
                </p>
              </Col>
            </Row>

            <Row>
              <Col md={{ size: 3 }} className="mb-4 pr-0">
                <CardImg
                  className="our-community-icons"
                  top
                  src="img/landing-page-srf-icon-v2.png"
                  alt="Card image cap"
                />
                <h3 style={{ color: "black" }} className="mt-3">
                  Stay Relevant, Forever
                </h3>
              </Col>
              <Col md={{ size: 3 }} className="mb-4 pr-0">
                <CardImg
                  className="our-community-icons"
                  top
                  src="img/landing-page-skill-building-icon-v2.png"
                  alt="Card image cap"
                />
                <h3 style={{ color: "black" }} className="mt-3">
                  Marked to Market Skill Building
                </h3>
              </Col>
              <Col md={{ size: 3 }} className="mb-4 pr-0">
                <CardImg
                  className="our-community-icons"
                  top
                  src="img/landing-page-coding-challenges-icon-v2.png"
                  alt="Card image cap"
                />
                <h3 style={{ color: "black" }} className="mt-3">
                  Problem-Solving & Coding Challenges
                </h3>
              </Col>
              <Col md={{ size: 3 }}>
                <CardImg
                  className="our-community-icons"
                  top
                  src="img/landing-page-industry-partnerships-icon-v2.png"
                  alt="Card image cap"
                />
                <h3 style={{ color: "black" }} className="mt-3">
                  Industry Partnerships
                </h3>
              </Col>
            </Row>
          </Container>
        </div>

        <div style={{ backgroundColor: "white" }}>
          <Container fluid>
            <Row>
              <Col sm={{ size: 4, offset: 8 }}>
                <CardImg
                  top
                  src="img/landing-page-atl-skyline-sliced-v2.png"
                  alt="Card image cap"
                  className="ml-3"
                />
              </Col>
            </Row>
          </Container>
        </div>

        <Container className="pt-0 pb-0">
          <Row>
            <Col sm={{ size: 6, offset: 1 }}>
              <h1 style={{ marginTop: "8rem" }} className="mb-3 text-left">
                CIO Defined Curriculum
              </h1>
              <hr
                className="heading-underline mb-4"
                style={{ marginLeft: "0%", marginRight: "92%" }}
              />
              <p className="text-left off-white">
                The first of its kind. Our employer partnerships are not just
                about creating talent showcases. We focus on the lifetime job
                opportunity for everyone, and work to help you add the skills
                most demanded by employers even when future technology changes.
                This can help companies keep their teams relevant and adaptable.
                Learn more about our Stay Relevant, Forever™ approach by
                contacting us today.
              </p>
              <Col sm={{ size: 3 }} className="pl-0 mt-5">
                <Link to="/browse">
                  <Button className="courses-button">Learn More</Button>{" "}
                </Link>
              </Col>
            </Col>
            <Col>
              <CardImg
                top
                src="img/landing-page-course-card-design.png"
                alt="Card image cap"
                style={{ height: "600px", objectFit: "contain" }}
              />
            </Col>
          </Row>
        </Container>

        <div className="pt-5" style={{ backgroundColor: "white" }}>
          <Container>
            <Row className="mt-5 mb-3">
              <Col
                md={{ size: 12 }}
                lg={{ size: 6 }}
                className="margin-between-cards d-flex"
              >
                <Row>
                  <Col
                    xs={{ size: 12 }}
                    sm={{ size: 2 }}
                    lg={{ size: 3 }}
                    className="d-flex justify-content-xl-end justify-content-start align-items-start pr-0 pb-4"
                  >
                    <CardImg
                      className="d-icons pr-0"
                      top
                      src="img/landing-page-employer-partnerships-icon-v2.png"
                    />
                  </Col>
                  <Col sm={{ size: 10 }} lg={{ size: 9 }}>
                    <Card className="differentiators-cards">
                      <CardBody className="pt-0 card-body">
                        <h1
                          style={{ color: "black" }}
                          className="differentiators-header"
                        >
                          Employer Partnerships
                        </h1>
                        <hr
                          className="heading-underline"
                          style={{ marginLeft: "0%", marginRight: "92%" }}
                        />
                        <p
                          style={{ color: "black" }}
                          className="differentiators-text off-white"
                        >
                          The first of its kind. Our employer partnerships are
                          not just about creating talent showcases to them. We
                          focus on the lifetime job opportunity for everyone and
                          work to help you add the skills most demanded by
                          employers even when future technology changes. Our
                          employer partnerships go deep to help companies keep
                          their teams relevant and adaptable with the
                          fast-changing technologies. Employers - Learn more
                          about our Stay Relevant, Forever™ approach by
                          contacting us today.
                        </p>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </Col>

              <Col
                md={{ size: 12 }}
                lg={{ size: 6 }}
                className="margin-between-cards  d-flex"
              >
                <Row>
                  <Col
                    xs={{ size: 12 }}
                    sm={{ size: 2 }}
                    lg={{ size: 3 }}
                    className="d-flex justify-content-xl-end justify-content-start align-items-start pr-0 pb-4"
                  >
                    <CardImg
                      className=" d-icons  pr-0"
                      top
                      src="img/landing-page-grow-your-career-icon-v2.png"
                    />
                  </Col>
                  <Col sm={{ size: 10 }} lg={{ size: 9 }}>
                    <Card className="differentiators-cards">
                      <CardBody className="pt-0 card-body">
                        <h1
                          style={{ color: "black" }}
                          className="differentiators-header"
                        >
                          Grow Your Career, Not Debt
                        </h1>
                        <hr
                          className="heading-underline"
                          style={{ marginLeft: "0%", marginRight: "92%" }}
                        />
                        <p
                          style={{ color: "black" }}
                          className="differentiators-text off-white"
                        >
                          Lighthouse focuses on evolving your career
                          step-by-step. We believe that ‘earning’ & ‘learning’
                          should be part of the same sentence. And that feels
                          right too. With that mindset, once accepted, then we
                          will be your guide throughout your career as it
                          evolves or you decide to take new opportunities. We
                          focus on the lifetime job opportunity for a student
                          and work to help you augment the skills most demanded
                          at any time. This can help you stay relevant with the
                          latest technology and adaptable with the market. Learn
                          more about our Stay Relevant, Forever™ approach by
                          contacting us today.
                        </p>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row>
              <Col sm={{ size: 8, offset: 2 }}>
                <Col sm={{ size: 6, offset: 3 }}>
                  <CardImg
                    top
                    src="img/landing-page-atl-skyline-v2.png"
                    alt="Card image cap"
                    className="mt-5"
                  />
                </Col>
                <h1 style={{ color: "black" }} className=" mb-3">
                  Mentors for Success
                </h1>
                <hr className="heading-underline mb-4" />
                <p style={{ color: "black" }}>
                  Staying relevant takes more than just learning new skills. It
                  requires on-going guidance and accountability. We don’t leave
                  students to figure out their next steps on their own. We
                  provide mentorship from industry experienced mentors and to
                  help bring inspiration into the future. Equipped with help,
                  students can approach their careers and the tech industry with
                  confidence. You can even reach our mentors after your
                  graduation.
                </p>
                <Link to="/">
                  <Button className="courses-button mt-4">Request Info</Button>{" "}
                </Link>
              </Col>
            </Row>

            <Questionform
              title={'  Learn More About The Lighthouse Learning Method'}
          textTitle={'We’d love to help you out!'}
          text={'Schedule a call with one of our Student Advisors. From curriculum to payment plans - our experts are happy to help.'}
            />
           
          </Container>
        </div>
        <div style={{ backgroundColor: "white" }}>
          <Container fluid>
            <Row>
              <Col sm={{ size: 4 }}>
                <CardImg
                  top
                  src="img/landing-page-atl-skyline-sliced-footer-v2.png"
                  alt="Card image cap"
                  className="mt-5"
                  style={{ marginLeft: "-2rem" }}
                />
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    );
  }
}

export default LandingPage;
